<template>
  <div>
    <div class="container">
      <div class="inner">
        <h1 class="main-title">{{ $t('view.component.user.terms.header') }}</h1>
        <UserFormTerms />
      </div>
    </div>
  </div>
</template>

<script>
import UserFormTerms from '@/orange/components/User/FormTerms'
export default {
  name: 'UserTermsView',
  components: { UserFormTerms }
}
</script>

<style lang="scss" src="../../assets/scss/components/_login-register.scss" scoped></style>
